// All static content for the PWT marketing site — verbatim from the company profile.

export const NAV_LINKS = [
  { id: "about", label: "Who we are" },
  { id: "services", label: "What we do" },
  { id: "mission", label: "Mission & Vision" },
  { id: "ecosystem", label: "Our symbol" },
  { id: "partners", label: "Partners" },
  { id: "applications", label: "Applications" },
  { id: "contact", label: "Contact" },
];

// Exact wording from the company profile, page 3.
export const SERVICES = [
  {
    number: "01",
    title: "Innovation & Strategy",
    description: "Strategic planning, business model innovation, market entry strategy.",
  },
  {
    number: "02",
    title: "Training, Coaching & Head Hunting",
    description:
      "Leadership development, talent acquisition, organizational capability building.",
  },
  {
    number: "03",
    title: "M&A and Inorganic Growth Support",
    description: "Due diligence, deal structuring, post-merger integration.",
  },
  {
    number: "04",
    title: "Digital, AI & Cyber-Secure Transformation",
    description: "Digital roadmap, AI implementation, cybersecurity frameworks.",
  },
  {
    number: "05",
    title: "IP Strategy",
    description: "Intellectual property portfolio, patent strategy, IP monetization.",
  },
  {
    number: "06",
    title: "Corporate Venture Building",
    description:
      "New venture creation, intrapreneurship programs, spin-off execution.",
  },
  {
    number: "07",
    title: "Internationalisation",
    description: "Market entry, local partnerships, cross-border operational setup.",
  },
  {
    number: "08",
    title: "Compliance & Sustainable Growth",
    description: "Regulatory compliance, ESG strategy, sustainable business models.",
  },
  {
    number: "09",
    title: "Media & Brand Strategy",
    description:
      "Brand architecture, communication strategy, media presence and storytelling.",
  },
  {
    number: "10",
    title: "Operational Excellence",
    description:
      "Process optimization, lean methodologies, performance management and continuous improvement.",
  },
];

export const PARTNERS = [
  { name: "Magis", focus: "Innovation & Strategy", url: "https://www.magis-company.com/" },
  { name: "Dikton", focus: "Head Hunting / HR support", url: "https://dikton.it/" },
  { name: "Orbyta", focus: "Digital and AI Transformation", url: "https://orbyta.it/tech/" },
  { name: "TXT Ennova", focus: "Digital and AI Transformation", url: "https://txtennova.it/" },
  { name: "Feat Ventures", focus: "Corporate Venture Building", url: "https://featventures.com/" },
  { name: "Tmega", focus: "Internationalisation", url: "https://tmegaconsultores.com/main.html" },
  { name: "Open Group Italia", focus: "Compliance & Sustainable Growth", url: "https://www.opengroupitalia.it/" },
  { name: "Digistart Media", focus: "Media and Brand Strategy", url: "https://www.digistartmedia.com/" },
  { name: "Notarbartolo & Gervasi", focus: "IP Strategy", url: "https://www.ngpatent.it/it/" },
  { name: "OdeXa", focus: "Operational Excellence", url: "https://odexa.com/it/" },
];

// Exact wording from pages 8–9 of the company profile.
export const APPLICATIONS = [
  {
    step: "01",
    title: "From innovation strategy to augmented reality implementation",
    steps: [
      {
        n: "1",
        partner: "Magis",
        text:
          "Outlined the strategic guidelines for a telecommunications company over the next three years. Among the key challenges: enhancing network maintenance efficiency through the adoption of augmented reality and artificial intelligence.",
      },
      {
        n: "2",
        partner: "Feat Ventures",
        text:
          "Focused on validating the concept of an on-demand platform of professionals — comprising multiple small-scale but highly widespread companies — to support peak activity periods throughout the year.",
      },
      {
        n: "3",
        partner: "Orbyta",
        text:
          "Developed augmented reality headsets, supported by AI algorithms, to enable maintenance teams to reduce service times and accelerate fault isolation through a digital twin of the line requiring intervention.",
      },
    ],
  },
  {
    step: "02",
    title: "From R&D project to change management",
    steps: [
      {
        n: "1",
        partner: "Open Group",
        text:
          "Identified an opportunity for the wholesale fruit and vegetable company to launch a new order procurement process from small local retailers, aimed at improving delivery service efficiency.",
      },
      {
        n: "2",
        partner: "Orbyta",
        text:
          "Enabled the new process by designing and implementing an AI-powered platform capable of interpreting orders received through various communication channels and integrating them into the company's software system.",
      },
      {
        n: "3",
        partner: "Dikton",
        text:
          "Took charge of organizing knowledge-sharing sessions on the new corporate system to overcome resistance to change and foster new AI-based efficiency initiatives.",
      },
    ],
  },
];

// Only two values, as confirmed by the founder.
export const VALUES = [
  {
    label: "Performance",
    description:
      "Outcomes measured by tangible client impact — each engagement delivers the results companies need to move forward.",
  },
  {
    label: "Trust",
    description:
      "The foundation of every collaboration — between PWT, its partners and its clients. Shared accountability, shared success.",
  },
];

// Page 2 — three pillars of the model
export const PILLARS = [
  {
    label: "Trust-Based Collaboration",
    description:
      "Partners share clients, insights, and accountability to deliver holistic solutions.",
  },
  {
    label: "Specialized Excellence",
    description:
      "Each boutique brings deep domain expertise — no generalist compromises.",
  },
  {
    label: "Scalable Ecosystem",
    description:
      "Clients access a full suite of capabilities without large-firm overhead.",
  },
];

export const MISSION_TEXT =
  "To always provide the right partner, empowering companies to reach their goals with confidence and trust.";

export const VISION_TEXT =
  "To become the world's largest network of multi-boutique firms supporting both large and small companies through their transformations and challenges.";

export const CONTACT_EMAIL = "information@pwtsystem.com";
export const LINKEDIN_URL =
  "https://www.linkedin.com/company/pwt-performance-with-trust/?viewAsMember=true";
